import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import CategoryPage from '../../../components/Category/pages/List';
import { ModulePermissionProps } from '../../../../../common/module/types';

const SystemConfig =  {
  filterName: 'component.filterTitle.promotion-material-category',
  blockName: 'component.formTitle.promotion-material-category',
  blockType: 'promotionMaterialCategory',
  moduleType: 'Promotion',
  addSuccessText: 'global.submit.success'
}

const PromotionCategoryPage: FC<RouteComponentProps & ModulePermissionProps> = (props) => {
  return (
    <CategoryPage { ...props } { ...SystemConfig } />
  )
};

export default PromotionCategoryPage;
